import { Input } from "@trussle/external-components";
import React, { HTMLAttributes } from "react";
import { useFormContext } from "./context/FormContext";
import { FF2Step } from "./types";
import { MortgagePurpose } from "../../../types/common";

export const PurposeInput: React.FC<HTMLAttributes<HTMLDivElement>> = (props) => {
  const {
    formData,
    setFormData,
    setStep
  } = useFormContext();

  return (
    <div {...props}>
      <Input
        key={formData.mortgagePurpose}
        name="mortgagePurpose"
        label="What is your mortgage for?"
        variant="select"
        value={formData.mortgagePurpose}
        onChange={(e) => {
          const value = e.target.value as MortgagePurpose;
          setFormData((prev) => ({
            ...prev,
            mortgagePurpose: value
          }));

          setStep(value as unknown as FF2Step);
        }}
        options={[
          {
            label: "",
            value: "",
            hidden: true
          },
          {
            label: "I want to buy a property",
            value: "purchase"
          },
          {
            label: "I want to remortgage",
            value: "remo"
          },
          {
            label: "I want to buy a property to let out",
            value: "purchase_to_let"
          }
        ]}
      />
      <Input
        name="propertyValue"
        variant="currency"
        label="Property value"
        value={formData.propertyValue}
        onChange={(e) => {
          setFormData((prev) => ({
            ...prev,
            propertyValue: e.target.value
          }));
        }}
      />
    </div>
  );
};
